import { toast } from 'react-toastify';

import { CustomErrorToast } from '@shared/components/customErrorToast';
import { CustomSuccessToast } from '@shared/components/customSuccessToast';

type SuccessToastOptions = {
  title: string;
  description: string;
};

const defaultToastOptions = {
  closeButton: false,
  autoClose: 5000,
  icon: false,
} as const;

const hasMessage = (value: unknown): value is { message: unknown } =>
  typeof value === 'object' && value !== null && 'message' in value;

export const resolveAmbienceSettingsErrorMessage = (
  error: unknown,
  fallbackMessage: string,
): string => {
  if (error && typeof error === 'object' && 'data' in error && hasMessage(error.data)) {
    return String(error.data.message);
  }

  return fallbackMessage;
};

export const showAmbienceSettingsSuccessToast = ({ title, description }: SuccessToastOptions) => {
  toast.success(CustomSuccessToast, {
    ...defaultToastOptions,
    data: {
      title,
      description,
    },
  });
};

export const showAmbienceSettingsErrorToast = (message: string) => {
  toast.error((props) => <CustomErrorToast {...props} message={message} />, {
    ...defaultToastOptions,
  });
};
